import styled from '@emotion/styled'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import LogoutIcon from '@mui/icons-material/Logout'
import { useNavigate } from 'react-router-dom'
import { SyntheticEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  Tooltip,
  IconButton as MuiIconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material'

import { useAuth } from '../../../hooks/useAuth'
import { UserGroups } from '@/types'
import { AuthorizationGuard } from '@/components'

const IconButton = styled(MuiIconButton)`
  background: ${({ theme }) => theme.palette.secondary.light};
  border-radius: 5px;
  padding: 10px;
  font-size: 14px;

  svg {
    color: ${({ theme }) => theme.palette.green[600]};
    width: 22px;
    height: 16px;
  }
`

function NavbarUserDropdown() {
  const navigate = useNavigate()
  const { signOut, user } = useAuth()
  const { t } = useTranslation('common')
  const [anchorMenu, setAnchorMenu] = useState<HTMLElement | null>(null)

  const toggleMenu = (event: SyntheticEvent) => {
    setAnchorMenu(event.currentTarget as HTMLElement)
  }

  const closeMenu = () => {
    setAnchorMenu(null)
  }

  const handleSignOut = async () => {
    await signOut()
    closeMenu()
    navigate('/auth/sign-in')
  }

  const handleProfileClick = () => {
    closeMenu()
    navigate('/researcher-profile')
  }

  const getInitials = () => {
    let result = ''

    if (user?.first_name) {
      result = result.concat(user?.first_name.toUpperCase()[0])
    }

    if (user?.last_name) {
      result = result.concat(user?.last_name.toUpperCase()[0])
    }

    return result
  }

  return (
    <>
      <Tooltip title={t('menu.userMenu')}>
        <IconButton
          aria-owns={Boolean(anchorMenu) ? 'user-menu' : undefined}
          aria-haspopup="true"
          onClick={toggleMenu}
          size="large"
        >
          {getInitials()}
        </IconButton>
      </Tooltip>
      <Menu
        id="user-menu"
        anchorEl={anchorMenu}
        open={Boolean(anchorMenu)}
        onClose={closeMenu}
      >
        <AuthorizationGuard
          allowedGroups={[UserGroups.EMPLOYEE]}
          redirect={false}
        >
          <MenuItem onClick={handleProfileClick}>
            <ListItemIcon>
              <AccountCircleIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t('menu.researcherProfile')}</ListItemText>
          </MenuItem>
        </AuthorizationGuard>
        <MenuItem onClick={handleSignOut}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t('menu.signOut')}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  )
}

export default NavbarUserDropdown
